<template>
  <div class="page-container">
    <div class="user-center-container">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="8">
          <div class="wrapper">
            <div class="container-left">
              <el-avatar
                :size="80"
                shape="square"
                src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
              ></el-avatar>
              <div class="user-name">{{ userInfo.userName }}</div>
              <div class="user-class">{{ CLASS_NAMES[userClass] }}</div>
              <div
                v-if="inWaitingList === 1 && userClass < 2"
                class="user-name"
              >
                You have joined the waiting list.
              </div>
              <el-button
                v-if="!inWaitingList"
                class="upgrade-btn"
                type="primary"
                :loading="joiningWL"
                @click="upgradeClass"
                >Upgrade</el-button
              >
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="16">
          <div class="wrapper">
            <div class="title-wrapper">
              <div class="title">Profile</div>
              <div>
                <el-button type="primary" @click="backToIndex">Back</el-button>
                <el-button
                  type="danger"
                  icon="el-icon-switch-button"
                  @click="onSignOutClick"
                  >Log out</el-button
                >
              </div>
            </div>
            <hr class="horizontal-rule" />
            <div class="container-right">
              <div class="row" v-for="(value, key) in userInfo" :key="key">
                <div class="key">{{ KEY_NAMES[key] }}</div>
                <div class="value">{{ value }}</div>
                <button
                  :class="[
                    'edit-btn',
                    EDITABLE_KEYS.indexOf(key) > -1 ? '' : 'hidden',
                  ]"
                  class="edit-btn"
                  @click="edit(key)"
                >
                  Edit
                </button>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import logo from "@/assets/Deepreport_idea_beta.svg";
import { getUserInfo, joinWaitingList, editUserInfo } from "@/api/user.js";

export default {
  name: "userCenter",
  data() {
    return {
      // 用户信息各字段的中文名称映射
      KEY_NAMES: {
        userName: "User Name",
        userEmail: "Email",
        userRegion: "Region",
        userInstitution: "Affiliation",
      },
      // 用户等级名称映射
      CLASS_NAMES: {
        0: "Free Plan",
        1: "Standard Plan",
        2: "Premium Plan",
      },
      // 前后端字段对应：
      KEY_INTERFACE: {
        userRegion: "region",
        userInstitution: "institution",
      },
      EDITABLE_KEYS: ["userRegion", "userInstitution"],
      userInfo: {
        // userName: "",
        // userEmail: "",
        // userRegion: "",
        // userInstitution: "",
      },
      userClass: 1,
      inWaitingList: false,
      joiningWL: false,
      logo: logo,
    };
  },
  methods: {
    // 返回首页
    backToIndex() {
      this.$router.push("/");
    },
    // 编辑账号信息
    async edit(key) {
      this.$prompt(`Input New ${this.KEY_NAMES[key]}`, "Edit", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        inputPlaceholder: this.userInfo[key],
      })
        .then(async ({ value }) => {
          let editInfo = {};
          editInfo[this.KEY_INTERFACE[key]] = value;
          await editUserInfo(editInfo);
          this.$message({
            type: "success",
            message: `Successfully Revise ${this.KEY_NAMES[key]} to ${value}`,
          });
          this.userInfo[key] = value;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Cancel Input",
          });
        });
    },
    // 点击登出
    onSignOutClick() {
      Vue.$cookies.remove("userName");
      Vue.$cookies.remove("userLevel");
      Vue.$cookies.remove("accessToken");
      Vue.$cookies.remove("userID");
      this.$store.commit("SET_NAME", "");
      this.$store.commit("SET_USER_LEVEL", "");
      this.$router.push("/");
    },
    // 升级用户等级
    async upgradeClass() {
      this.joiningWL = true;
      try {
        await joinWaitingList();
        this.inWaitingList = true;
      } catch (err) {
        console.log("ERROR", err);
      }
      this.joiningWL = false;
    },
  },
  created() {
    if (!Vue.$cookies.get("accessToken")) {
      // 如果没有登录态则跳转登录
      // this.$router.push("signin");
      window.location.href = `${process.env.VUE_APP_BASE_API}/v1/login`;
    }
  },
  async mounted() {
    try {
      const { data: res } = await getUserInfo();
      this.inWaitingList = res.wait;
      this.userInfo = {
        userName: res.username,
        userEmail: res.email,
        userRegion: res.region,
        userInstitution: res.institution,
      };
      this.userClass = res.level;
      this.$store.commit("SET_NAME", res.username);
      this.$store.commit("SET_USER_LEVEL", res.level);
    } catch (err) {
      console.log("ERROR", err);
    }
  },
};
</script>
<style lang="less" scoped>
.page-container {
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    ),
    linear-gradient(117.26deg, #58e1ff -12.31%, #0047ff 100%);
  min-height: 100vh;
  box-sizing: border-box;
  font-family: "Source Sans Pro", "PingFang SC";
}
.user-center-container {
  position: absolute;
  top: 5vh;
  left: 5vw;
  width: 90vw;
  height: 90vh;
  background: rgba(255, 255, 255, 0.5);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(20px);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}
.el-row {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: row;
}
.hidden {
  visibility: hidden;
}
.wrapper {
  border-radius: 5px;
  background: white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  .title-wrapper {
    display: flex;
    height: 40px;
    justify-content: space-between;
    padding-top: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .title {
    text-align: left;
    font-size: 24px;
    line-height: 40px;
    font-weight: 700;
  }
  .container-right {
    margin-left: 15px;
    width: calc(100% - 30px);
    .row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      border-bottom: 1px solid #ccc;
    }

    .key {
      font-weight: bold;
      text-align: left;
      width: 100px;
    }
    .edit-btn {
      padding: 5px 10px;
      background-color: #409eff;
      color: #fff;
      border: none;
      border-radius: 5px;
      width: 80px;
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    }
  }
  .container-left {
    padding-top: 20px;
    font-size: 16px;
    text-align: center;
    .user-name {
      line-height: 24px;
      margin-top: 8px;
      font-weight: 500;
    }
    .user-class {
      line-height: 24px;
      margin-top: 8px;
      color: #aaa;
      margin-bottom: 8px;
    }
    .upgrade-btn {
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }
}
hr.horizontal-rule {
  margin: 15px 0px 8px;
  border: 0;
  height: 1px;
  background: #222;
  background-image: linear-gradient(to right, #ccc, #333, #ccc);
}

@media (max-width: 768px) {
  .el-row {
    flex-direction: column;
  }
  .el-col {
    margin-bottom: 20px;
  }
  .wrapper {
    height: 100%;
  }
}
</style>
